var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.728 32.728A18 18 0 117.272 7.273a18 18 0 0125.456 25.455zM18.55 26.68l10.267-10.267a1.538 1.538 0 00.004-2.234 1.538 1.538 0 00-2.235.004l-9.135 9.136-4.038-4a1.538 1.538 0 00-2.234-.003c-.64.6-.639 1.636.004 2.235l5.13 5.129c.599.644 1.638.644 2.238 0z"
  })));
}
export default SvgCheckmarkCircle;